module.exports = __webpack_public_path__ + "img/saudi-professional-league-292.9aea432d.png";